import { render, staticRenderFns } from "./DatatableListFilterTemplate.vue?vue&type=template&id=a708e964&"
import script from "./DatatableListFilterTemplate.vue?vue&type=script&lang=ts&"
export * from "./DatatableListFilterTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports